<p-card>
  
  <div class="grid">
    <div class="col-6 md:col-6 lg:col-6 breadcrumbrightmenu">
      <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
      <app-sdlcmenu></app-sdlcmenu> -->
      <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
      (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
      </button>
    </div> 
  </div> 
 
<p style="font-size:large; font-weight:bolder; color:crimson">
      The selected organisation will be permanently removed from Complinity and all related data and uploads will be deleted.
</p>


    <div class="grid">
      <div class="col-6">
        <label for="orgid" class="bold-red-text">Organisation</label>
        <p-dropdown 
        [options]="orgList" 
        [(ngModel)]="orgid"
        optionLabel="name"
        optionValue="orgid" 
        styleClass="fixed-width-dropdown-filter" 
        inputId="orgid" 
        (onChange)="gettabledata($event)"
        placeholder="Select"
        [filter]="true" 
        appendTo="body" 
        [resetFilterOnHide]="true" 
        [showClear]="true">
        </p-dropdown>
      </div>
      <div class="col-1 mt-1">
        <p-button label="Remove Organisation" styleClass="reset-btn" pTooltip="Remove Organisation" (click)="removeorganisation()"
          tooltipPosition="right"></p-button>
      </div>
        
</div>
</p-card>

<p-card>

<p style="font-size:large; font-weight:bolder; color:crimson">

<p style='color:red;font-weight:bolder'>YOU HAVE REQUESTED FOR AN ORGANISATION REMOVAL FROM COMPLINITY.<br/>
	Please note that this is an irreversible process. Once you remove, the data can never be retrieved from the database or storage. It will be PERMANENTLY REMOVED<br/>
	Please note that all the documents uploaded by this organisation on the S3 server will be permanently erased.<br/>
	<p style='color:red;font-weight:bolder'>{{attachcount}} documents will be deleted<br/>
	Also note that the data of this organisation in the following tables will be permanently removed<br/>
</p>

  <p-table 
    #dt 
    [value]="tableData" 
    responsiveLayout="scroll" 
    >
    
        <ng-template pTemplate="header">
          <tr>
            <th>Table Name<p-sortIcon field="tablename"></p-sortIcon></th>
            <th>Number of Rows<p-sortIcon field="rownumbers"></p-sortIcon></th>
          </tr>
        </ng-template>
  
       <ng-template pTemplate="body" let-data>
        <tr style="vertical-align: top;">
           <td style="width: 75% !important;">{{data["tablename"]}}</td>
           <td style="width: 25% !important;">{{data["count"]}}</td>
        </tr>
       </ng-template>
  </p-table>
</p-card>

